import { Icon, Tooltip } from 'antd';
import React from 'react';
import * as S from './styles';
import { getStatusIcon, getStatusMessage } from '../../../../../utils/helper';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { JOB_DETAILS_UI } from '../TranslationValues';

const AbortionDetailsTab = ({ batch, users }) => {
    const { t } = useTranslation();
    const channel = batch?.channelType?.toLowerCase();

    return (
        <S.AbortionDetailsCard>
            <div className='icon-container'><Icon type='info-circle' /></div>
            <div>
                <p>
                    <strong>{t(JOB_DETAILS_UI.ABORTED_BY.key, JOB_DETAILS_UI.ABORTED_BY.value)} </strong>
                    <strong>{users.find(user=> user.id === batch.abortedBy)?.displayName || ''}</strong></p>
                <p>{batch.abortedTime && moment(batch.abortedTime).format('Do MMM YYYY, h:mm A')} </p>
                <p>
                    <strong>{t(JOB_DETAILS_UI.REASON.key, JOB_DETAILS_UI.REASON.value)} : </strong>
                    {batch.abortedReason ? batch.abortedReason.length < 99
                        ? <span>{batch.abortedReason}</span>
                        : <Tooltip title={batch.abortedReason} overlayStyle={{ maxWidth: 450 }}>
                            <span>{batch.abortedReason?.substring(0, 99).trim()}...</span>
                          </Tooltip>
                    : ' -'}
                </p>
            </div>
        </S.AbortionDetailsCard>
    );
};

export default AbortionDetailsTab;
